import { defineMessages } from "react-intl";

const messages = defineMessages({
    submitButton: {
        description: "Submit button for Google sign-up form",
        defaultMessage: "Continue to sign up"
    }
});

export default messages;
